import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../hooks";
import { useCompleteStep } from "../hooks/useCompleteStep";
import { useNavigate } from "react-router-dom";
import { CheckCircle, Users, ExternalLink } from "lucide-react";

const EmployeesStep: React.FC = () => {
  const navigate = useNavigate();
  const employees = useAppSelector((s) => s.employees.employees);
  const { complete, onboarding, stepIndex, dashboardPath } = useCompleteStep("employees");
  const [hasVisited, setHasVisited] = useState(false);

  useEffect(() => {
    if (employees.length > 0 && !onboarding.completedSteps[stepIndex]) {
      complete();
    }
  }, [employees, onboarding.completedSteps, stepIndex, complete]);

  if (onboarding.completedSteps[stepIndex]) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
        <h3 className="text-xl font-semibold text-gray-800">Employees Added!</h3>
        <p className="text-gray-500 mt-2">You have {employees.length} employee(s) set up.</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto text-center">
      <div className="rounded-xl border bg-white p-8 shadow-sm">
        <Users className="h-12 w-12 text-primary mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">Add Your Employees</h3>
        <p className="text-gray-500 text-sm mb-6">
          Add cashiers and managers to your business so they can help run your stores.
        </p>

        <button
          onClick={() => {
            setHasVisited(true);
            navigate(`${dashboardPath}/employees`);
          }}
          className="form-btn w-full flex items-center justify-center gap-2"
        >
          <span>Go to Employees</span>
          <ExternalLink className="h-4 w-4" />
        </button>

        {hasVisited && employees.length === 0 && (
          <button
            onClick={() => complete()}
            className="mt-4 w-full rounded border border-gray-300 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50"
          >
            I've added my employees
          </button>
        )}
      </div>
    </div>
  );
};

export default EmployeesStep;
